import api, { isAPIError } from 'containers/api'
import { selectToken } from 'containers/authentication/authenticationSlice'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { IETLlogs, IOrganization } from 'types'

const useGetETLlogs = (organization: IOrganization) => {
  const token = useSelector(selectToken)

  const [etlLogs, setEtlLogs] = useState<IETLlogs>()
  const [latestETLDate, setLatestETLDate] = useState<Date>()
  const [errorGettingLogs, setErrorGettingLogs] = useState<string>('')
  const [loadingLogs, setLoadingLogs] = useState<boolean>(false)
  const [hasMore, setHasMore] = useState<boolean>(false)
  const [nextCursor, setNextCursor] = useState<string | undefined>()
  const [loadingMore, setLoadingMore] = useState<boolean>(false)

  const getETLlogs = async (append: boolean = false) => {
    try {
      if (append) {
        setLoadingMore(true)
      } else {
        setLoadingLogs(true)
      }

      const rawLogs = await api.getETLlogs({
        organizationId: organization.id,
        token,
        before: append ? nextCursor : undefined,
        limit: 50,
      })

      const logs = rawLogs.all_logs

      if (append && etlLogs) {
        // Merge new logs with existing logs
        setEtlLogs({ ...etlLogs, ...logs })
      } else {
        setEtlLogs(logs)
        setLatestETLDate(rawLogs.latest_etl_date)
      }

      setHasMore(rawLogs.has_more || false)
      setNextCursor(rawLogs.next_cursor)

      setLoadingLogs(false)
      setLoadingMore(false)
    } catch (err) {
      setLoadingLogs(false)
      setLoadingMore(false)
      if (isAPIError(err) && typeof err.response.data.detail == 'string') {
        setErrorGettingLogs(err.response.data.detail)
      }
    }
  }

  const loadMoreLogs = () => {
    if (hasMore && !loadingMore) {
      getETLlogs(true)
    }
  }

  return {
    getETLlogs,
    etlLogs,
    latestETLDate,
    loadingLogs,
    errorGettingLogs,
    hasMore,
    loadMoreLogs,
    loadingMore
  }
}

export default useGetETLlogs
